export default class WindRose {
  constructor(refCanvas, width = 100, height = 100) {
    this.container = refCanvas;
    this.container.width = width;
    this.container.height = height;
    this.width = width;
    this.height = height;
    this.ctx = this.container.getContext("2d");
    this.X0 = this.ctx.canvas.width / 2;
    this.Y0 = this.ctx.canvas.height / 2;
    this.radius = Math.min(this.X0, this.Y0);
    this.ctx.translate(this.X0, this.Y0);
    this.ctx.rotate(-Math.PI / 2);
    this._strokeRose();
    this._ring([
      this.radius / 4,
      this.radius / 2,
      (this.radius * 3) / 4,
      this.radius,
    ]);
  }
  _ring(radiuses) {
    for (let radius of radiuses) {
      this.ctx.beginPath();
      this.ctx.strokeStyle = "#aaa";
      this.ctx.arc(0, 0, radius, 0, 2 * Math.PI);
      this.ctx.stroke();
    }
  }
  _strokeRose() {
    for (let i = 1; i <= 12; i++) {
      this.ctx.rotate((2 * Math.PI) / 12);
      this.ctx.moveTo(this.radius - 2, 0);
      this.ctx.lineTo(this.radius, 0);
    }
    this.ctx.stroke();
    //create a radial gradiant
    const grad = this.ctx.createRadialGradient(0, 0, 0, 0, 0, this.radius);
    grad.addColorStop(0, "rgba(255,255,255,0.9)");
    grad.addColorStop(0.3, "rgba(0,0,210,0.6)");
    grad.addColorStop(1, "rgba(200,0,0,0.6)");
    this.ctx.fillStyle = grad;
    this.ctx.arc(0, 0, this.radius, 0, 2 * Math.PI);
    this.ctx.fill();
  }
  arrow(angle, force = 10, efface = true, colour = "#ffff00") {
    if (efface) {
      this.clear();
      this._strokeRose();
    }
    //dessine une fleche selon un angle donné
    this.ctx.rotate((angle * Math.PI) / 180);
    const scale = Math.min(force / 40, 1);
    this.ctx.scale(scale, scale);
    this.strokeStyle = "red";
    this.ctx.fillStyle = colour;
    this.ctx.beginPath();
    this.ctx.moveTo(-this.radius, 0);
    this.ctx.lineTo(-this.radius - 10, -10);
    this.ctx.lineTo(this.radius, 0);
    this.ctx.lineTo(-this.radius - 10, 10);
    this.ctx.closePath();
    this.ctx.fill();
    //restaure l'angle et l'échelle du canevas
    this.ctx.scale(1 / scale, 1 / scale);
    this.ctx.rotate((-angle * Math.PI) / 180);
  }
  clear() {
    // efface tout le canvas(attention le canvas est pivoté de 90° ce qui inverse les coordonnées)
    this.ctx.clearRect(
      -this.height / 2,
      -this.width / 2,
      this.height,
      this.width
    );
  }
}
